<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
========================================================================================== -->

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{
          Object.entries(this.data).length === 0
            ? "ADD NEW"
            : this.showFarm
            ? "UPDATE"
            : "ADD NEW"
        }}
        HARVEST
      </h4>
      <h6 v-if="!showFarm">
        {{ farm ? farm.value.a : null }}
      </h6>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <span v-if="showFarm" class="mt-5 ml-1 text-sm">Source Farm</span>
        <v-select
          v-show="showFarm"
          v-model="farm"
          class="inputx w-full"
          name="farm"
          :options="fO"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('farm')">{{
          errors.first("farm")
        }}</span>

        <br />
        <span class="mt-5 ml-1 text-sm">Destination Factory</span>
        <v-select
          v-model="factory"
          class="inputx w-full"
          name="factory"
          :options="faO"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('factory')">{{
          errors.first("factory")
        }}</span>

        <br />
        <span class="mt-5 ml-1 text-sm">Transit Truck</span>
        <v-select
          class="inputx w-full"
          name="truck"
          v-model="truck"
          :options="tO"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('truck')">{{
          errors.first("truck")
        }}</span>

        <br />
        <span class="mt-5 ml-1 text-sm">Operator</span>
        <v-select
          class="inputx w-full"
          name="operator"
          v-model="operator"
          :options="op0"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('operator')">{{
          errors.first("operator")
        }}</span>

        <vs-input
          disabled="true"
          label="Capacity in m3"
          class="mt-5 w-full"
          name="m3"
          v-model="m3"
          v-validate="'required|numeric'"
        />
        <span class="text-danger text-sm" v-show="errors.has('m3')">{{
          errors.first("m3")
        }}</span>

        <br />
        <span class="text-sm"> Date</span>
        <datepicker placeholder="Start Date" v-model="date"></datepicker>

        <vs-textarea
          label="Description"
          v-model="description"
          class="mt-5 w-full"
        />
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
    farms: {
      type: Array,
      default: () => [],
    },
    factories: {
      type: Array,
      default: () => [],
    },
    trucks: {
      type: Array,
      default: () => [],
    },
    operators: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else if (Object.entries(this.data).length === 1) {
        this.initValues();
        this.$validator.reset();
        let { a } = JSON.parse(JSON.stringify(this.data));
        this.farm = a;
        this.showFarm = false;
      } else {
        let { _id, _rev } = JSON.parse(JSON.stringify(this.data));
        // this.id = _id;
        // this.rev = _rev;
        // // a: this.farm.value,
        // //     b: this.factory.value,
        // //     c: this.truck.value,
        // //     d: 0,
        // //     e: this.m3,
        // this.farm = {}
        // this.m3 = e;
        // this.description = h;
        this.initValues();
      }
    },
    truck(val) {
      this.m3 = parseInt(val ? val.value.b : 0);
    },
  },
  created() {},
  data() {
    return {
      id: null,
      rev: null,
      farm: null,
      factory: null,
      truck: null,
      description: null,
      operator: null,
      m3: 0,
      date: Date.now(),
      showFarm: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  computed: {
    // TODO: Add active flag to each object
    fO() {
      let ta = [];
      this.farms.map((obj) => {
        ta.push({
          label: `${obj.a} - ${obj.b}`,
          value: obj,
        });
      });
      return ta;
    },
    tO() {
      let ta = [];
      this.trucks.map((obj) => {
        ta.push({
          label: `${obj.a} (${obj.b} cbm) - ${obj.d} `,
          value: obj,
        });
      });
      return ta;
    },
    faO() {
      let ta = [];
      this.factories.map((obj) => {
        ta.push({
          label: `${obj.a} - ${obj.b}`,
          value: obj,
        });
      });
      return ta;
    },
    op0() {
      let ta = [];
      this.operators.map((obj) => {
        ta.push({
          label: `${obj.a} - ${obj.d}`,
          value: obj,
        });
      });
      return ta;
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return (
        !this.errors.any() &&
        this.farm &&
        this.factory &&
        this.truck &&
        this.operator
      );
    },
  },
  methods: {
    initValues() {
      if (this.data._id) return;
      this.id = null;
      this.farm = null;
      this.factory = null;
      this.truck = null;
      this.operator = null;
      this.description = "";
    },
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.notify({
            color: "warning",
            title: "Processing",
            text: "Processing Data",
          });
          const obj = {
            _id: this.id,
            _rev: this.rev,
            a: this.farm.value,
            b: this.factory.value,
            c: this.truck.value,
            d: this.description,
            e: this.$session.get("user") || { b: "Unknown User" },
            f: this.date.getTime(),
            g: true,
            h: this.operator.value,
            y: this.date.getTime(),
            z: 9,
          };

          if (this.id !== null && this.rev !== null) {
            this.$store
              .dispatch("harvests/updateHarvest", obj)
              .then((r) => {
                this.$vs.notify({
                  color: "success",
                  title: "Success",
                  text: r,
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "Error",
                  text: err,
                });
              });
          } else {
            delete obj._id;
            delete obj._rev;
            this.$store
              .dispatch("harvests/addHarvest", obj)
              .then((r) => {
                this.$vs.notify({
                  color: "success",
                  title: "Success",
                  text: r,
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "Error",
                  text: err,
                });
              });
          }
        }
      });
    },
  },
  components: {
    VuePerfectScrollbar,
    "v-select": vSelect,
    Datepicker,
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
